<script lang="tsx">
import { defineComponent, type PropType } from 'vue'
import { type JSX } from 'vue/jsx-runtime'

type JsxInTemplate = () => JSX.Element | null
export default defineComponent({
  props: {
    jsx: {
      type: Function as PropType<JsxInTemplate>,
      required: true
    }
  },
  setup(props) {
    return () => props.jsx()
  }
})

</script>
